export type TypographyVariant =
  | '10ftCallout'
  | '10ftBody'
  | '10ftHeadline'
  | '10ftTitle1'
  | '10ftTitle2'
  | '10ftTitle3'
  | '10ftCaption1'
  | '10ftCaption2'
  | '10ftFootnote'
  | '10ftLargeTitle'
  | '10ftCraveTitle3';

export const typographyVariantClasses: Record<TypographyVariant, string> = {
  '10ftCallout': 'font-bold text-[1.5rem] leading-[1.875rem]',
  '10ftBody': 'font-normal text-[1.625rem] leading-[2rem]',
  '10ftHeadline': 'text-[1.75rem] font-bold leading-[2rem]',
  '10ftTitle1': 'font-bold text-[3rem] leading-[3.375rem]',
  '10ftTitle2': 'font-bold text-[2.25rem] leading-[2.625rem]',
  '10ftTitle3': 'font-bold text-[2rem] leading-[2.25rem]',
  '10ftCaption1': 'font-medium text-[1.313rem] leading-[1.563rem]',
  '10ftCaption2': 'font-bold text-[1.313rem] leading-[2rem]',
  '10ftFootnote': 'text-[1.125rem] font-medium leading-[1.5rem]',
  '10ftLargeTitle': 'font-bold text-[4.5rem] leading-[4.75rem]',
  '10ftCraveTitle3': 'mb-16 text-[1.75rem] font-bold leading-[2rem]',
};
